import { debugInfo } from '../util/debug';
import { HtmlId } from '../enums/elementId';

/**
 * Create text link component with onClick action.
 *
 * @param id - ID of the element.
 * @param onClick - OnClick event.
 * @returns the container of the link
 */
export const mountTextLink = (id: HtmlId, onClick: () => void): HTMLElement | null => {
    const containerEl = document.getElementById(id);

    if (!containerEl) {
        debugInfo('Couldn\'t mount ButtonLink component with id: ', id);

        return null;
    }

    containerEl.onclick = (e: Event) => {
        e.preventDefault();
        e.stopPropagation();

        onClick();
    };

    return containerEl;
};
